import Vue from 'vue'

export default class NotificationService {

    showError(text: string, title: string = 'Error'){
        NotificationService._showMessage(text, title, 'error')
    }

    showSuccess(text: string, title: string = 'Success'){
        NotificationService._showMessage(text, title, 'success ')
    }

    showWarn(text: string, title: string = 'Info'){
        NotificationService._showMessage(text, title, 'warn')
    }

    private static _showMessage(text: string, title: string, type: string, group: string = 'main'){
        Vue.notify({
            group: group,
            title: title,
            text: text,
            type: type
        });
    }
}
